// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1191":"0b82c791","1331":"e0ffb18f","5327":"b47b8f22","7837":"2ca77775"}[chunkId] + ".chunk.css";
};